import { gql } from "urql";

export const GET_LOAN_BY_OWNER: any = gql(`
    query GetLoanByOwner{
        GetLoanByOwner {
            _id
            name
            type
            purpose
            ltv
            owner {
                _id
                name
                lastname
            }
            investmentExperience
            onboarding
            loanData
        }  
    }
`)

export const GET_LOAN_BY_ID: any = gql(`
    query GetLoanById($id: String!){
        GetLoanById(id: $id) {
            _id
            name
        }  
    }
`)

export const GET_LOANS: any = gql(`
    query GetLoans($search: String, $page: Int, $limit: Int){
        GetLoans(search: $search, page: $page, limit: $limit) {
            data {
              _id
              name
              state
              progress
              type
              purpose
              ltv
              investmentExperience
              onboarding
              createdAt
              loanData
              salesforceData
              tasks {
                  _id
                  key
                  name
                  state
                  hidden
              }
              owner {
                  _id
                  name
                  lastname
                  email
                  phone 
                  loans {
                      _id
                      name
                  }
                  userCreator {
                    _id
                  }

              }
            }
            total
            page
            totalPages  
        }
    }
`)

export const GET_LOAN_DOCUMENTS: any = gql(`
    query GetLoanDocByLoan($loanId: String!){
        GetLoanDocByLoan(loanId: $loanId) {
            _id
            key
            name
            description
            expiration
            state
            hidden
            isDeleted
            ownership {
                _id
            }
            file {
                key
                name
                url
            }
            files {
              key
              name
              url
            }
        }  
    }
`)

export const GET_LOAN_CLOSED_BY_LOAN: any = gql(`
    query GetLoansClosed($loanId: String!){
        GetLoansClosed(loanId: $loanId) {
            _id
            state
        }  
    }
`)

export const DOWNLOAD_FILES_PENDING: any = gql(`
    query DownloadFilesPending($loanId: String!, $taskId: String){
        DownloadFilesPending(loanId: $loanId, taskId: $taskId) {
            key
            name
            url
            task {
                _id
                name
            }
            taskResponse {
                key
                label
            }
        }  
    }
`)
